<template>
  <v-card v-if="editData" flat>
    <v-card-text class="">
      <v-row class="pa-0 ma-0">

        <v-col cols="12" md="12" sm="12" class="py-0 ma-0">
          <v-btn color="primary" outlined @click="addStudentsDialog = true; getStudent()" class="mb-3" :loading="isLoading">

            <v-icon class="mx-1">mdi-account-plus</v-icon> {{ $t('mail.AddStudentsToTheExam') }}
          </v-btn>
          <v-text-field v-model="studentsSearch2" append-icon="mdi-magnify" :label="$t('writeWhatYouSearch')" outlined
            dense hide-details>
            <!-- mutiple delete students -->
            <template v-slot:append-outer>
              <v-card-actions style="margin-top: -6px" class="pt-0">
                <v-btn :title="$t('delete')" @click="removeStudents(studentsSelect.map(s => s.studentGuid))" :loading="isLoading"
                  :disabled="!studentsSelect.length">
                  <v-icon color="red darken-1">mdi-close</v-icon>
                </v-btn>
              </v-card-actions>
            </template>

          </v-text-field>


          <v-data-table :items="examsStudentsList" :headers="examStudentsListHeaders" item-key="studentGuid" :loading="isLoading"
            @toggle-select-all="toggle" v-model="studentsSelect" selectable-key="studentGuid" show-select
            :search="studentsSearch2" dense>
            <template v-slot:item.actions="{ item }">
              <v-btn :title="$t('delete')" icon color="red darken-1" @click="removeStudents([item.studentGuid])" :loading="isLoading">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>

          </v-data-table>

        </v-col>

        <v-col cols="12" md="12" sm="12" class="py-0 ma-0">

        </v-col>
      </v-row>
    </v-card-text>


    <v-dialog v-model="addStudentsDialog" max-width="800px" persistent>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title> {{ $t("mail.AddStudentsToTheExam") }} </v-toolbar-title><v-spacer></v-spacer>
        <v-btn icon dark @click="addStudentsDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="px-4 pb-4">
        <v-tabs v-model="tab" @change="SelectedStudentsIds = []">
          <v-tab>
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">mdi-account-multiple</v-icon>
            {{ $t("exam.FromCurrentSection") }}
          </v-tab>
          <v-tab v-if="hasRoleAddStudentsFromAllDepartments">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">mdi-account-supervisor</v-icon>
            {{ $t("exam.FromDepartment") }}
          </v-tab>
          <v-tab-item>
            <v-row class="mt-2">
              <v-col cols="12" md="12" sm="12">
                <v-text-field dense hide-details v-model="studentsSearch3" append-icon="mdi-magnify"
                  :label="$t('writeWhatYouSearch')" outlined>
                </v-text-field>
                <v-card flat class="pa-0 ma-0" max-height="500" min-height="500" style="overflow-y: auto;">
                  <v-data-table :search="studentsSearch3" :headers="studentsTableHeadres" :items="studentList" dense :loading="isLoading"
                    item-key="studentGuid" show-select v-model="SelectedStudentsIds"
                    selectable-key="studentGuid" @toggle-select-all="selectAllStudents">
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item v-if="hasRoleAddStudentsFromAllDepartments">
            <v-row class="mt-2">
              <v-col v-if="hasRoleAddStudentsFromAllDepartments">
                <v-autocomplete dense hide-details v-model="selectedDepartment" :items="departments" outlined
                  :label="$t('Department')" item-text="departmentsName" item-value="departmentGuid" clearable
                  @change="getStages()">
                </v-autocomplete>
              </v-col><v-col>
                <v-autocomplete dense hide-details v-model="selectedStage" :items="stages" outlined
                  :label="$t('profile.stageName')" :item-text="getStageText" item-value="stageGuid" clearable
                  @change="GetStudentsByStage()">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-text-field dense hide-details v-model="studentsSearch" append-icon="mdi-magnify"
                  :label="$t('writeWhatYouSearch')" outlined>
                </v-text-field>
                <v-card flat class="pa-0 ma-0" max-height="500" min-height="500" style="overflow-y: auto;">
                  <v-data-table :search="studentsSearch" :headers="studentsTableHeadres" :items="students" dense :loading="isLoading"
                    item-key="studentGuid" show-select v-model="SelectedStudentsIds"
                    selectable-key="studentGuid" @toggle-select-all="selectAllStudents">
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
        <v-card-actions class="pa-1">
          <v-btn   outlined color="teal darken-1" @click="addStudent()" :loading="isLoading"
            :disabled="!SelectedStudentsIds[0]">
            {{ $t('add') }}
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="red darken-1" @click="addStudentsDialog = false">
            {{ $t('close') }}
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </v-card>
</template>

<script>

export default {
  props: ["examGuid", "examQuestions"],

  data() {
    return {
   
      studentsSelect: [],
      studentList: [],
      editData: this.examQuestions.exam,
      isLoading: false,
      teacherRoles: [],
      departments: [],
      stages: [],
      students: [],
      selectedDepartment: null,
      selectedStage: null,
      hasRoleAddStudentsFromAllDepartments: false,
      studentsTableHeadres: [
        { text: this.$t('StudentCode'), value: 'studentCode' },
        { text: this.$t('studentName'), value: 'studentFullName' },
      ],
      examStudentsListHeaders: [
        { text: '#', value: 'actions', sortable: false, align: 'center', width: '70px' },
        { text: this.$t('StudentCode'), value: 'studentCode' },
        { text: this.$t('studentName'), value: 'studentName' },
        { text: this.$t('Department'), value: 'departmentName' },
        { text: this.$t('Stage'), value: 'stageNameWithStudy' },
      ],
      studentsSearch: "",
      studentsSearch2: "",
      studentsSearch3: "",
      SelectedStudentsIds: [],
      examsStudentsList: [],
      addStudentsDialog: false,
      tab: 0,
    };
  },
  computed: {


  
  },
  methods: {
    sendResultValues() {
      this.$emit("send-result-values", "carrier");
    },
    addStudent() {
      const data = {
        examGuid: this.editData.guid,
        subjectGuid: this.editData.subjectGuid,
        sectionGuid: this.editData.sectionGuid,
        studentGuids: this.SelectedStudentsIds.some(s => s.studentGuid) ? this.SelectedStudentsIds.map(a => a.studentGuid) : [],
      };
     this.isLoading = true;


      this.axios.put("Exams/AddStudents", data)
        .then((res) => {
          if (res.data.statusCode == 1) {
            this.getExamStudent();
            this.SelectedStudentsIds = [];


            this.$swal.fire({
              title: this.$t('operationAccomplishedSuccessfully'),
              text: "",
              icon: "success",
              confirmButtonText: this.$t('close'),
              toast: true,
              position: "bottom-start",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });
          } else if (res.data.statusCode == 3) {
            this.$swal.fire({
              title: this.$t("errors.ExamNotFound"),
              text: "",
              icon: "error",
              confirmButtonText: this.$t("close")
            });
          } else {
            this.$swal.fire({
              title: this.$t("errors.AnErrorOccurredTheOperationDidNotCompleteSuccessfully"),
              text: "",
              icon: "error",
              confirmButtonText: this.$t("close")
            });
          }

          // console.log(res);
        })
        .catch(() => {
          this.$swal.fire({
            title: this.$t('AnErrorOccurredDuringTheProcess'),
            text: "",
            icon: "error",
            confirmButtonText: this.$t('close'),
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getExamStudent() {
      this.isLoading = true;
      this.axios.get(`Exams/GetStudents?ExamGuid=${this.editData.guid}`).then((res) => {
        // console.log(res.data.data);
        this.studentsSelect = [];
        this.examsStudentsList = res.data.data;
        if (this.tab === 0) {
          this.getStudent();
        } else {
          this.GetStudentsByStage();
        }
      })
        .catch(() => { })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getStudent() {
      if (this.editData.sectionGuid && this.editData.subjectGuid) {
        this.isLoading = true;
        this.axios.get(
          `Students/Get?sectionGuid=${this.editData.sectionGuid}&subjectGuid=${this.editData.subjectGuid}`
        )
          .then((res) => {
            if (res.data.data) {
              this.studentList = res.data.data.filter(s => !this.examsStudentsList.some(es => es.studentGuid === s.studentGuid));
            }

            // console.log(this.studentList);
          })
          .catch(() => { })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    getTeacherRoles() {
      this.axios.get("Teachers/GetTeacherRoles").then((res) => {
        this.teacherRoles = res.data.data;
        if (this.teacherRoles.length > 0 && this.teacherRoles.includes("AbilityToAddStudentsToExamFromAllDepartments")) {
          this.hasRoleAddStudentsFromAllDepartments = true;
          this.getDepartments();
        } else {
          this.hasRoleAddStudentsFromAllDepartments = false;
        }

      });
    },
    getDepartments() {
      if (!this.hasRoleAddStudentsFromAllDepartments) {
        this.departments = [];
        this.stages = [];
        this.students = [];
        this.SelectedStudentsIds = [];
        this.selectedDepartment = null;
        this.selectedStage = null;
        return;
      }
      this.students = [];
      this.SelectedStudentsIds = [];
      this.selectedStage = null;
      this.stages = [];

      this.isLoading = true;

      this.axios.get("Students/GetDepartments").then((res) => {
        this.departments = res.data.data;
      })
        .catch(() => { })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getStages() {
      if (!this.hasRoleAddStudentsFromAllDepartments) {
        this.departments = [];
        this.stages = [];
        this.students = [];
        this.SelectedStudentsIds = [];
        this.selectedDepartment = null;
        this.selectedStage = null;
        return;
      }
      this.SelectedStudentsIds = [];
      this.selectedStage = null;
      if (!this.selectedDepartment) {
        this.stages = [];
        this.students = [];
        this.SelectedStudentsIds = [];
        this.selectedStage = null;
        return;
      }
      this.isLoading = true;

      this.axios.get("Students/GetStages?departmentGuid=" + this.selectedDepartment).then((res) => {
        this.stages = res.data.data;
      })
        .catch(() => { })
        .finally(() => {
          this.isLoading = false;
        });
    },
    GetStudentsByStage() {
      if (!this.hasRoleAddStudentsFromAllDepartments) {
        this.departments = [];
        this.stages = [];
        this.students = [];
        this.SelectedStudentsIds = [];
        return;
      }
      this.students = [];
      this.SelectedStudentsIds = [];
      this.isLoading = true;
      this.axios.get("Students/GetStudentsByStage?stageGuid=" + this.selectedStage).then((res) => {
        this.students = res.data.data.filter(s => !this.examsStudentsList.some(es => es.studentGuid === s.studentGuid));
      })
        .catch(() => { })
        .finally(() => {
          this.isLoading = false;
        });
    },
    removeStudents(studentGuid) {
      //cannot delete student if entered to the exam
      //confirm deletion
      this.$swal
        .fire({
          title: this.$t("AreYouSureAboutTheOperation"),
          text: this.$t("exam.CannotDeleteStudentIfEnteredToTheExam"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("no"),
        })
        .then((result) => {
          if (result.value) {

            this.isLoading = true;
            this.axios.put(`Exams/RemoveStudentsFromExam/${this.editData.guid}`, studentGuid).then((res) => {
              if (res.data.statusCode == 1) {
                this.getExamStudent();
              }
            })
              .catch(() => { })
              .finally(() => {
                this.isLoading = false;
              });

          }
        });


    },
    getFieldText(item) {
      return `${item.stageName} - ${item.studyName}`;
    },
    getStageText(item) {
      return `${item.stageName} - ${item.studyType.studyName}`;;
    },
    selectAllStudents(event) {
      if (event.value === true) {
        if (this.tab === 0) {
          this.SelectedStudentsIds = this.studentList;
          return;
        }
        this.SelectedStudentsIds = this.students;
      } else {
        this.SelectedStudentsIds = [];
      }


    },
    toggle(event) {
      if (event.value === true) {
        this.studentsSelect = this.examsStudentsList;
      } else {
        this.studentsSelect = [];
      }

    },
  },
  created() {
    this.getTeacherRoles();

    this.getExamStudent();
  },
};
</script>

<style></style>
